import Vue from 'vue'
import Vuex from 'vuex'

import moment from 'moment'

import getters from './getters'
import mutations from './mutations'
import actions from './actions'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    mode: 'core',
    cookie: '',
    loading: false,
    page: {
      colors: {
        background_image: false,
        background_color: false,
        text_color: false,
        accent_color: false,
        accent_color2: false
      }
    },
    design:{
      badges: {
        'Alphonso': function () { return import('@core/components/badge/style/default.vue') },
        'Maria': function () { return import('@core/components/badge/style/roundet_small.vue') },
        'Maggy': function () { return import('@core/components/badge/style/leaf_small.vue') },
        'Rick': function () { return import('@core/components/badge/style/cells.vue') },
        'Toni': function () { return import('@core/components/badge/style/cells_small.vue') }
      },
      votings: {
        'Table': function () { return import('@core/components/votes/table.vue') },
        'Slider': function () { return import('@core/components/votes/slider.vue') },
        'Floating': function () { return import('@core/components/votes/floating.vue') },

      },
    },
    page_title: 'hello',
    language: 'de',
    user: false,
    boards: false,
    votes: false,
    vote_details: {

    },
    feedback: {

    },
    board_avg: {

    },
    target_pages: {

    },
    unread_chats: false
  },
  getters: getters,
  mutations,
  actions: actions
})
